<template>
  <v-app id="post-login">
    <v-main>
      <v-container class="fill-height" fluid :style="{ background: 'url(' + require('@/assets/bg.jpg') + ') center center / cover' }">
        <v-row align="center" justify="center">
          <v-overlay z-index="0" opacity="0.6" absolute></v-overlay>
          <v-overlay z-index="10" :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-col cols="12" md="8" lg="10">
            <v-card style="padding-block: 50px; padding-inline: 20px; border-radius: 20px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); align-items: center; text-align: center;">
              <v-card-title class="text-h3 text-center" style="text-align: center !important; display: flex; justify-content: center;">Suscripción</v-card-title>
              <v-card-subtitle class="text-center pt-4 pb-8">Selecciona tu plan de suscripción</v-card-subtitle>
              <stripe-pricing-table 
                :pricing-table-id="pricingTableId"
                :customer-session-client-secret="fields.token"
                :publishable-key="stripePublishableKey"></stripe-pricing-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js'
import UserService from '@/services/UserService'

export default {
  data: () => ({
    // campos del formulario
    user: null,
    loading: false,
    fields: {
      token: null
    },
    stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
    // IDs de las tablas de precios de Stripe según el tipo de vehículo
    pricingTables: {
      start: process.env.VUE_APP_STRIPE_PRICING_TABLES_START,
      pro: process.env.VUE_APP_STRIPE_PRICING_TABLES_PRO,
      enterprise: process.env.VUE_APP_STRIPE_PRICING_TABLES_ENTERPRISE
    }
  }),

  methods: {
    loadToken () {
      // Cargar el token de Stripe
      UserService.getClientSecret()
        .then((response) => {
          this.fields.token = response.data.data.client_secret
        })
        .catch((error) => {
          console.error('Error al cargar el token de Stripe:', error)
        })
    }
  },
  computed: {
    // getters y setters de los campos del formulario
    ...mapGetters(['CURRENT_USER', 'DEALER_ACTIVE_TYPES_COUNT', 'DEALER_HAS_TYPE']),

    pricingTableId () {
      // Obtener la cantidad de tipos activos usando el getter
      const activeTypesCount = this.DEALER_ACTIVE_TYPES_COUNT

      // Determinar la tabla basándose en la cantidad de tipos activos
      switch (activeTypesCount) {
        case 1:
          return this.pricingTables.start // Un solo tipo -> Tabla Start
        case 2:
          return this.pricingTables.pro // Dos tipos -> Tabla Pro
        case 3:
          return this.pricingTables.enterprise // Tres tipos -> Tabla Enterprise
        default:
          return this.pricingTables.start // Ninguno o más de 3 -> Tabla Start por defecto
      }
    }
  },

  created () {
    const script = document.createElement('script')
    script.src = 'https://js.stripe.com/v3/pricing-table.js'
    script.async = true
    document.body.appendChild(script)
    this.loadToken()
  }
}
</script>

<style scoped>
</style>
